module.exports = __webpack_public_path__ + "media/images/gallery/constellations/hercules/her_ir-6820df54f30676f53dae8dce58f349e7.jpg";